import React from "react";
import { useFormikContext } from "formik";
import Button from "@mui/material/Button";

export default function ToggleActiveButton({ active, onToggle }) {
  const { values, isSubmitting, setSubmitting } = useFormikContext();

  const handleClick = async () => {
    try {
      setSubmitting(true);
      await onToggle(values, !active);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Button
      variant="text"
      color={active ? "error" : "primary"}
      onClick={handleClick}
      disabled={isSubmitting}
    >
      {active ? "Deactivate" : "Activate"}
    </Button>
  );
}


